export const SORT_OPTIONS = ["popular", "trending", "newest", "alpha", "duration"];
export const EVENT_TYPES = ["sound.published", "sound.played"];
export const COMBO_LIMIT = 250;
export const COMBO_MIN_SOUNDS = 2;
export const COMBO_MAX_SOUNDS = 5;
export const MIME_TYPES = [
    "audio/mpeg",
    "audio/wav",
    "audio/ogg",
    "audio/webm",
    "audio/mp4",
    "audio/aac",
    "audio/flac",
];
//# sourceMappingURL=constants.js.map